import postWithResponse from '@services/api/common/postWithResponse';
import appConfig from '@configs/appConfig';
import { ftpConnections } from '@constants/appRoutes';

export const postFtpUpload = data =>
  postWithResponse(`${appConfig.baseUrl}${ftpConnections}upload`, data);
